'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataflowTooltipAttributesIds = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getDataflowTooltipAttributesIds = exports.getDataflowTooltipAttributesIds = function getDataflowTooltipAttributesIds(sdmxJson) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var dataflowAnnotationsIndexes = R.pathOr([], ['data', 'dataSets', 0, 'annotations'], sdmxJson);
  var dataflowAnnotations = R.props(dataflowAnnotationsIndexes, R.pathOr([], ['data', 'structure', 'annotations'], sdmxJson));

  var flagsAttrAnnotation = R.find(R.propEq('type', 'LAYOUT_FLAG'), dataflowAnnotations);
  var footnotesAttrAnnotation = R.find(R.propEq('type', 'LAYOUT_NOTE'), dataflowAnnotations);

  var customFlags = R.pipe(R.propOr('', 'title'), function (title) {
    return R.isNil(title) || R.isEmpty(title) ? [] : R.split(',', title);
  })(flagsAttrAnnotation || {});

  var customNotes = R.pipe(R.propOr('', 'title'), function (title) {
    return R.isNil(title) || R.isEmpty(title) ? [] : R.split(',', title);
  }, function (notes) {
    return R.difference(notes, customFlags);
  })(footnotesAttrAnnotation || {});

  var flags = R.isNil(flagsAttrAnnotation) ? R.difference(defaults.flags || [], customNotes) : customFlags;

  var notes = R.isNil(footnotesAttrAnnotation) ? R.difference(defaults.notes || [], flags) : customNotes;

  return { flags: flags, notes: notes };
};